import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../utils/authContext";
import { useCustomerContext } from "../../../../utils/customerContext";
import { useInvoiceContext } from "../../../../utils/invoiceContext";
import CreateInvoiceDetails from "./createInvoiceDetails";
import CreatePositions from "./createPositions";

function CreateContainer() {
    const [selectedCustomer, setSelectedCustomer] = useState({});
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [actionDate, setActionDate] = useState(new Date());
    const [actionDateTo, setActionDateTo] = useState(null);
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [tax, setTax] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [isPaid, setIsPaid] = useState(false);
    const { fetchCustomers } = useCustomerContext();
    const { handleCreateInvoice } = useInvoiceContext();
    const { user } = useAuth() || {};

    useEffect(() => {
        fetchCustomers();
    }, []);

    const handleInvoiceChange = useCallback(({ items }) => {
        setInvoiceItems(items || []);
    }, []);

    const handleDetailsChange = useCallback(({ selectedCustomer, actionDate, actionDateTo, invoiceDate, tax, paymentMethod, isPaid }) => {
        setSelectedCustomer(selectedCustomer || {});
        setActionDate(actionDate || new Date());
        setActionDateTo(actionDateTo ?? null);
        setInvoiceDate(invoiceDate || new Date());
        setTax(tax || 0);
        setPaymentMethod(paymentMethod || '');
        setIsPaid(isPaid ?? false);
    }, []);

    const handleCreate = useCallback(() => {
        handleCreateInvoice(selectedCustomer, actionDate, actionDateTo, invoiceDate, user, invoiceItems, paymentMethod, tax, isPaid);
    }, [selectedCustomer, actionDate, actionDateTo, invoiceDate, user, invoiceItems, paymentMethod, tax, isPaid]);

    return (
        <div className="createContainer">
            <div className="createComponentsContainer">
                <CreateInvoiceDetails onDetailsChange={handleDetailsChange} />
                <CreatePositions
                    onInvoiceChange={handleInvoiceChange}
                    handleCreateInvoice={handleCreate}
                />
            </div>
        </div>
    );
}

export default CreateContainer;